import {
  ProductDetailsSection_ArticleDetail_ManufacturerLane,
  ProductDetailsSection_ArticleDetail_ManufacturerLane_ManufacturerInfo,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/product_details.types';
import {COLORS, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';

export const ManufacturerInfo: FC<{
  manufacturerInfo?: ProductDetailsSection_ArticleDetail_ManufacturerLane;
}> = ({manufacturerInfo}) => {
  if (!manufacturerInfo) {
    return null;
  }

  return (
    <ManufacturerDetails>
      {manufacturerInfo.type?.$case === 'manufacturerInfo' && (
        <ManufacturerInfoDetails
          manufacturerInfo={manufacturerInfo.type.manufacturerInfo}
        />
      )}

      {manufacturerInfo.type?.$case === 'richText' && (
        <StyledRichText
          as="div"
          weight="w400"
          dangerouslySetInnerHTML={{
            __html: manufacturerInfo.type?.richText.text,
          }}
        />
      )}
    </ManufacturerDetails>
  );
};

const ManufacturerInfoDetails: FC<{
  manufacturerInfo: ProductDetailsSection_ArticleDetail_ManufacturerLane_ManufacturerInfo;
}> = ({manufacturerInfo}) => {
  return (
    <>
      <StyledText weight="w400">{manufacturerInfo.name}</StyledText>

      <div>
        {manufacturerInfo.addressLines.map((addressLine, index) => {
          return (
            <StyledText as="div" weight="w400" key={`addressLine-${index}`}>
              {addressLine}
            </StyledText>
          );
        })}
      </div>

      <div>
        {manufacturerInfo.contacts.map((contact, index) => {
          return (
            <StyledText weight="w400" key={`contact-${index}`}>
              {contact}
            </StyledText>
          );
        })}
      </div>
    </>
  );
};

const ManufacturerDetails = styled.dd`
  margin-inline-start: 0;
  gap: 10px;
  display: flex;
  flex-direction: column;
`;

const StyledText = styled(Text)`
  line-height: 1.43;
  // for legal reasons we should show as much text as we can, therefore, after if the text doesn't fit after 2 lines we show an ellipsis, although this is considered an edge case
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
  display: -webkit-box;
  overflow: hidden;
`;

const StyledRichText = styled(StyledText)`
  // helps breaking line for when /n is present
  white-space: pre-line;

  a {
    text-decoration: none;
    // we have no control over the link the manufacturer provides, so we disable the click event
    pointer-events: none;
    color: ${COLORS.Black};
  }
`;
